import 'url-search-params-polyfill';
import React, { useState, useEffect } from 'react';

import { getStripePublishableKey, getSupportBundleSeparate } from '../../../../common/utils/config';

import Button from '../UI/Button';
import Message from '../UI/Message';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(getStripePublishableKey());

function PanelForm() {
  const [message, setMessage] = useState('');
  const [bundle] = useState(getSupportBundleSeparate());

  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);

    if (query.get('success')) {
      setMessage('Support Bundle purchased! An e-mail with a link to access is on it\'s way to your inbox' );
    }

    if (query.get('canceled')) {
      setMessage("Order canceled -- continue to shop around and checkout when you're ready.");
    }
  }, []);

  const handleClick = async (event) => {
    const stripe = await stripePromise;

    const response = await fetch('/api/support_bundles', {
      method: 'POST',
    });

    const session = await response.json();

    // When the customer clicks on the button, redirect them to Checkout.
    const result = await stripe.redirectToCheckout({
      sessionId: session.id,
    });

    if (result.error) {
      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your customer
      // using `result.error.message`.
    }
  };

  return (
    <div className="notification">
      <div className="container">
        <div className="pro-landing-separator_inset">
          {message && <Message message={message}/> }
          {!message && <React.Fragment>
              <div className="pro-landing-separator_text">
                {`Not ready to sign up? Purchase our 'Support Bundle' separately for ${ bundle.price }`}
              </div>
              <div className="pro-landing-separator_action">
                <Button handleClick={handleClick}/>
              </div>
            </React.Fragment>
          }
        </div>
      </div>
    </div>
  );
}

export default PanelForm;



// WEBPACK FOOTER //
// ./app/javascript/components/buy_support_panel/components/Panel/Form.js